const U = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=85`;

export const estates = [
  {
    slug: "santal-house",
    name: "Santal House",
    location: "Ubud, Bali",
    cardPlace: { en: "Ubud · 4 bedrooms", id: "Ubud · 4 kamar tidur" },
    tag: { en: "Private estate", id: "Properti privat" },
    image: U("photo-1664876080601-acf03b40c5e3", 1200),
    heroImage: U("photo-1664876080601-acf03b40c5e3", 2200),
    nightly: 420,
    specs: [
      [{ en: "Bedrooms", id: "Kamar tidur" }, "4"],
      [{ en: "Bathrooms", id: "Kamar mandi" }, "4"],
      [{ en: "Guests", id: "Tamu" }, "8"],
      [{ en: "Pool", id: "Kolam renang" }, "18 m"],
      [{ en: "Land", id: "Lahan" }, "1,200 m²"],
      [{ en: "Staff", id: "Staf" }, "5"],
    ],
    description: {
      en: "Hidden above a river gorge in Ubud, Santal House is a study in stillness — aged teak, hand-cut stone and a pool that dissolves into the green. Days here are shaped around the light: slow mornings on the deck, afternoons between the library and the water, dinners under frangipani trees.",
      id: "Tersembunyi di atas lembah sungai di Ubud, Santal House adalah perwujudan ketenangan — jati tua, batu alam, dan kolam yang menyatu dengan hijaunya lembah. Hari-hari di sini mengikuti cahaya: pagi yang lambat di dek, sore antara perpustakaan dan kolam, dan makan malam di bawah pohon kamboja.",
    },
    amenities: {
      en: ["Infinity pool over the gorge", "Private chef on request", "Yoga shala & massage bale", "Full-time housekeeping team", "Airport transfer arranged", "Starlink Wi-Fi throughout"],
      id: ["Kolam infinity menghadap lembah", "Koki privat sesuai permintaan", "Shala yoga & bale pijat", "Tim housekeeping penuh waktu", "Penjemputan bandara diatur", "Wi-Fi Starlink di seluruh area"],
    },
    gallery: [
      { src: U("photo-1508178066614-b16ebcb84c00"), caption: { en: "Rice-terrace outlook", id: "Pemandangan sawah terasering" } },
      { src: U("photo-1737527852155-9720a5e2254f"), caption: { en: "Master suite", id: "Kamar tidur utama" } },
      { src: U("photo-1612347572521-d3e1956fc263"), caption: { en: "Outdoor lounge", id: "Ruang santai terbuka" } },
    ],
  },
  {
    slug: "casa-cinta",
    name: "Casa Cinta",
    location: "Canggu, Bali",
    cardPlace: { en: "Canggu · 3 bedrooms", id: "Canggu · 3 kamar tidur" },
    tag: { en: "New to Eden", id: "Baru di Eden" },
    image: U("photo-1613553474179-e1eda3ea5734", 1200),
    heroImage: U("photo-1613553474179-e1eda3ea5734", 2200),
    nightly: 340,
    specs: [
      [{ en: "Bedrooms", id: "Kamar tidur" }, "3"],
      [{ en: "Bathrooms", id: "Kamar mandi" }, "3"],
      [{ en: "Guests", id: "Tamu" }, "6"],
      [{ en: "Pool", id: "Kolam renang" }, "12 m"],
      [{ en: "Land", id: "Lahan" }, "800 m²"],
      [{ en: "Staff", id: "Staf" }, "4"],
    ],
    description: {
      en: "Minutes from Canggu’s cafés and surf, Casa Cinta turns inward — a walled garden, warm concrete and linen-soft bedrooms that make the outside world optional. It entertains beautifully: long-table dinners in the dining pavilion, sunset drinks by the pool.",
      id: "Hanya beberapa menit dari kafe dan pantai selancar Canggu, Casa Cinta berbalik ke dalam — taman berpagar, beton hangat, dan kamar selembut linen yang membuat dunia luar menjadi pilihan. Properti ini sempurna untuk menjamu: makan malam meja panjang di pavilion, minuman senja di tepi kolam.",
    },
    amenities: {
      en: ["Dining pavilion for 10", "Saltwater pool", "Surf & café guide curated", "Daily breakfast service", "Smart TV & sound system", "Scooter rental arranged"],
      id: ["Pavilion makan untuk 10 orang", "Kolam air asin", "Panduan selancar & kafe pilihan", "Layanan sarapan harian", "Smart TV & sound system", "Penyewaan skuter diatur"],
    },
    gallery: [
      { src: U("photo-1721222203415-69033eaf3bd1"), caption: { en: "Living room", id: "Ruang keluarga" } },
      { src: U("photo-1721222203586-314a1a33f521"), caption: { en: "Dining pavilion", id: "Pavilion makan" } },
      { src: U("photo-1540555700478-4be289fbecef"), caption: { en: "Garden at dusk", id: "Taman di senja hari" } },
    ],
  },
  {
    slug: "uma-laut",
    name: "Uma Laut",
    location: "Uluwatu, Bali",
    cardPlace: { en: "Uluwatu · 5 bedrooms", id: "Uluwatu · 5 kamar tidur" },
    tag: { en: "Ocean view", id: "Pemandangan laut" },
    image: U("photo-1675657144361-98ae33e6b6f9", 1200),
    heroImage: U("photo-1675657144361-98ae33e6b6f9", 2200),
    nightly: 560,
    specs: [
      [{ en: "Bedrooms", id: "Kamar tidur" }, "5"],
      [{ en: "Bathrooms", id: "Kamar mandi" }, "5"],
      [{ en: "Guests", id: "Tamu" }, "10"],
      [{ en: "Pool", id: "Kolam renang" }, "22 m"],
      [{ en: "Land", id: "Lahan" }, "1,800 m²"],
      [{ en: "Staff", id: "Staf" }, "7"],
    ],
    description: {
      en: "On the Bukit cliffs above Uluwatu, Uma Laut keeps the ocean in every frame. Five suites step down the hillside toward a 22-metre pool, and every evening ends the same way — the sky turning gold over the Indian Ocean, the house falling quiet except for the surf below.",
      id: "Di tebing Bukit di atas Uluwatu, Uma Laut membingkai samudra di setiap sudut. Lima suite menuruni lereng menuju kolam 22 meter, dan setiap senja berakhir dengan cara yang sama — langit keemasan di atas Samudra Hindia, dan rumah yang hening kecuali deburan ombak di bawahnya.",
    },
    amenities: {
      en: ["Cliff-edge infinity pool", "Ocean-view suites", "In-villa spa therapists", "Private gym", "Sunset barbecue deck", "Dedicated villa manager"],
      id: ["Kolam infinity di tepi tebing", "Suite pemandangan laut", "Terapis spa ke villa", "Gym privat", "Dek barbekyu matahari terbenam", "Manajer villa khusus"],
    },
    gallery: [
      { src: U("photo-1580587771525-78b9dba3b914"), caption: { en: "Pool above the surf", id: "Kolam di atas ombak" } },
      { src: U("photo-1729615385477-2e5ebc2ef43d"), caption: { en: "Stone bathroom", id: "Kamar mandi batu alam" } },
      { src: U("photo-1512917774080-9991f1c4c750"), caption: { en: "Arrival garden", id: "Taman kedatangan" } },
    ],
  },
];

export const findEstate = (slug) => estates.find((e) => e.slug === slug);
